export default "assets/images/icons/property-marker-8ef22c30.svg";